<template>
  <div class="page-container">
    <div class="auth-box">
      <h1 class="auth-title">{{ $t('login') }}</h1>

      <div class="auth-form">
        <input
          v-model="username"
          class="input-field"
          :placeholder="$t('username')"
          @keyup.enter="handleLogin"
        />
        <input
          v-model="password"
          type="password"
          class="input-field mt-1"
          :placeholder="$t('password')"
          @keyup.enter="handleLogin"
        />
        <p v-if="error" class="auth-error">{{ error }}</p>
        <button class="btn btn-primary mt-2" style="width:100%" @click="handleLogin" :disabled="loading">
          {{ loading ? '...' : $t('login') }}
        </button>
      </div>

      <p class="auth-switch mt-2 text-sm text-center">
        <router-link to="/register" class="text-secondary">{{ $t('register') }}</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { login } from '../api'

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      error: '',
      loading: false
    }
  },
  methods: {
    handleLogin() {
      this.error = ''
      if (!this.username || !this.password) {
        this.error = this.$t('username_rule')
        return
      }
      this.loading = true
      login(this.username, this.password).then(res => {
        const d = res.data.data
        localStorage.setItem('markjy_token', d.token)
        localStorage.setItem('markjy_username', d.username)
        localStorage.setItem('markjy_is_admin', d.is_admin ? 'true' : 'false')
        localStorage.setItem('markjy_user_id', d.user_id)
        this.$router.push('/')
      }).catch(err => {
        const msg = err.response && err.response.data ? err.response.data.message : this.$t('network_error')
        this.error = msg
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.auth-box {
  max-width: 380px;
  margin: 60px auto 0;
}
.auth-title {
  font-size: 1.3rem;
  font-weight: 600;
  text-align: left;
  margin-bottom: 24px;
}
.auth-form {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.auth-error {
  color: #d32f2f;
  font-size: 0.8rem;
  margin-top: 8px;
}
.auth-switch a {
  text-decoration: underline;
}
</style>
